import { memo, useEffect } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { useSettingAccessUserGroupPageContext } from '../../../../../pages/Setting/Access/UserGroup';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { TextInput } from '../../../../global/Input';
import { CancelButton, SaveButton } from '../../../../global/Button';
import { useCreateGroup, useEditGroupByUUID } from '../../../../../hook/query/groupCRUD';
import ActionBar from '../../../../global/Widget/ActionBar';
import { useSnackbar } from 'notistack';
import { EHelperText } from '../../../../../utilitie/validation';
import objectSameKeyValue from '../../../../../utilitie/objectSameKeyValue';
import { getEntireFormStyle } from '../../../../global/EntireForm';

export interface IUserGroupInformationProps {
    useInfoForm: UseFormReturn<IGroupFormValues, object>
}

export interface IGroupFormValues {
    uuid:string,
    id?: any,
    name: string,
    description: string,
}

export default function UserGroupInformation({ useInfoForm }: IUserGroupInformationProps) {

    const { enqueueSnackbar } = useSnackbar()
    const { uuid, defaultValues, setActionLog } = useSettingAccessUserGroupPageContext()

    const { mutateAsync: createGroup, isLoading: createGroupLoading } = useCreateGroup()
    const { mutateAsync: editGroupByUUID, isLoading: editGroupByUUIDLoading } = useEditGroupByUUID(uuid)

    const { control, reset, handleSubmit, formState: { isValid } } = useInfoForm

    const _handleSubmit = async (values: FieldValues) => {
        if (uuid) {
            await editGroupByUUID(values as IGroupFormValues).then(data => {
                setActionLog('edit')
                reset(data)
                enqueueSnackbar(EHelperText.UPDATED_SUCCESS, { variant: 'success' })
            }).catch(error => {
                enqueueSnackbar(EHelperText.UPDATED_ERROR, { variant: 'error' })
            })
        } else {
            await createGroup(values as IGroupFormValues).then(data => {
                enqueueSnackbar('เพิ่มกลุ่มสำเร็จ', { variant: 'success' })
            }).catch(error => {
                enqueueSnackbar(EHelperText.AN_ERROR_OCCURRED + 'การเพิ่มกลุ่ม', { variant: 'error' })
            })
        }
    }

    const handleCancel = () =>{
        if(uuid){
            reset(defaultValues.useInfoForm)
        }else{
            setActionLog('cancel-create')
        }
    }

    const isReadyToAction = !createGroupLoading && !editGroupByUUIDLoading && isValid && !defaultValues.useInfoForm.is_master

    return (
        <Stack component="form" onSubmit={handleSubmit(_handleSubmit, error => console.error(error))} height={'100%'} sx={{...getEntireFormStyle(!!defaultValues.useInfoForm.is_master)}}>
            <Box flex={1} px={3} pt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextInput id='name' name='name' label='ชื่อกลุ่ม' control={control} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextInput id='description' name='description' label='รายละเอียด' control={control} />
                    </Grid>
                </Grid>
            </Box>
            <ActionBar>
                <CancelButton onClick={handleCancel} disabled={!isReadyToAction && !!uuid}>ยกเลิก</CancelButton>
                <SaveButton type="submit" disabled={!isReadyToAction}>บันทึก</SaveButton>
            </ActionBar>
        </Stack>
    );
}

